






























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { Location } from "vue-router";
import Users from "@/admin/components/shared/Users.vue";
import { UserSearchDocument } from "@/shared/types";
import { UserListActionButtonOptions } from "@/admin/types";
import Button from "@/shared/components/ui/Button.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useOpenSearchIndexStore } from "@/admin/store/openSearchIndex";
import { formatDateTimeStringWithZone } from "@/shared/dateString";
@Component({
  components: {
    Button,
    Users
  }
})
export default class AdminUtilityReindexUser extends Vue {
  notifierStore = useNotifierStore();
  openSearchIndexStore = useOpenSearchIndexStore();
  formatDateTimeStringWithZone = formatDateTimeStringWithZone;

  get actionButtonOptions (): UserListActionButtonOptions {
    return {
    show: true,
    text: "Reindex",
    click: this.showConfirmReindex
    };
  }
  cognitoUsername = "";
  emailAddress = "";
  isLoaded = false;
  showConfirmModal = false;

  @Prop()
  page: number;

  @Prop()
  routeToUserList: (page: number) => Location;

  mounted () {
    this.initialize();
  }

  initialize () {
    this.emailAddress = "";
    this.cognitoUsername = "";
    this.isLoaded = true;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  cancelReindex () {
    this.showConfirmModal = false;
    this.emailAddress = "";
    this.cognitoUsername = "";
  }

  showConfirmReindex (user: { email: string, cognitoUsername: string }) {
    this.emailAddress = user.email;
    this.cognitoUsername = user.cognitoUsername;
    this.openSearchIndexStore.getUserDocument(this.cognitoUsername);
    this.showConfirmModal = true;
  }
  get userSearchDocument (): UserSearchDocument {
      return this.openSearchIndexStore.userDocument;
  }
  confirmReindex () {
    const email = this.emailAddress;
    const cognito = this.cognitoUsername;
    this.openSearchIndexStore.reindexUser(cognito)
      .catch(this.handleError);

    this.showConfirmModal = false;
    this.emailAddress = "";
    this.cognitoUsername = "";
  }

  onClose () {
    this.showConfirmModal = false;
    this.emailAddress = "";
    this.cognitoUsername = "";
  }
}
